

















import Vue from 'vue'
import moment from 'moment'

interface ReplacementRow {
  isChecked: boolean
  Adressverantwortliche: string | null
  Bis: string | null
  Dauer: string
  EinsatzAm: string
  Notiz: string | null
  ProjektSichtDetailId: number
  STVID: number
  Stellvertretung: string | null
  StellvertretungID: number
  Von: string | null
  Wochentag: string | null
  VonBis: string
}

interface ComponentData {
  hourStart: string
  minuteStart: string
  hourEnd: string
  minuteEnd: string
  hourRules: Array<Function>
  minuteRules: Array<Function>
}

export default Vue.extend({
  name: 'TimePickerCell',

  components: {},

  props: {
    rowData: Object as () => ReplacementRow
  },

  data (): ComponentData {
    return {
      hourStart: "",
      minuteStart: "",
      hourEnd: "",
      minuteEnd: "",
      hourRules: [
        (v: string) => !!v || this.$t('absencesPage.badValue'),
        (v: string) => {
          const numVal = parseInt(v, 10)
          return (v.indexOf('.') === -1 && numVal >= 0 && numVal < 24) || this.$t('absencesPage.badValue')
        }
      ],

      minuteRules: [
        (v: string) => !!v || this.$t('absencesPage.badValue'),
        (v: string) => {
          const numVal = parseInt(v, 10)
          return (v.indexOf('.') === -1 && numVal >= 0 && numVal < 60) || this.$t('absencesPage.badValue')
        }
      ],
    }
  },

  watch: {},

  computed: {},

  methods: {
    onFieldValueChange (): void {
      const form: any = this.$refs['form']

      if (form.validate()) {
        this.rowData.Von = `${this.hourStart}:${this.minuteStart}`
        this.rowData.Bis = `${this.hourEnd}:${this.minuteEnd}`
        this.rowData.VonBis = `${this.rowData.Von} - ${this.rowData.Bis}`

        let dateFrom: string = `${moment().format('DD.MM.YYYY')} ${this.rowData.Von}`
        let dateTo: string = `${moment().format('DD.MM.YYYY')} ${this.rowData.Bis}`

        if(moment(dateFrom, 'DD.MM.YYYY HH:mm').isAfter(moment(dateTo, 'DD.MM.YYYY HH:mm'))) {
          dateTo = moment(dateTo, 'DD.MM.YYYY HH:mm').add(1, 'day').format('DD.MM.YYYY HH:mm')
        }

        const duration = moment.duration(moment(dateTo, 'DD.MM.YYYY HH:mm').diff(moment(dateFrom, 'DD.MM.YYYY HH:mm')));
        const dauer = duration.asHours().toFixed(2)

        this.rowData.Dauer = dauer
      }
    }
  },

  mounted () {
    this.hourStart = this.rowData.Von ? this.rowData.Von.split(':')[0] : ''
    this.minuteStart = this.rowData.Von ? this.rowData.Von.split(':')[1] : ''
    this.hourEnd = this.rowData.Bis ? this.rowData.Bis.split(':')[0] : ''
    this.minuteEnd = this.rowData.Bis ? this.rowData.Bis.split(':')[1] : ''
  }
})

